import { action, observable, makeObservable } from 'mobx';
import {contentLoaders, SuccessResponse} from '../../../../domain';
import {HttpPromiseState, SaveStateHolder} from '../../../../lib/helpers';

export class DeleteLessonStore implements SaveStateHolder {
  @observable.ref
  save: HttpPromiseState<SuccessResponse> | null;

  constructor(readonly lessonId: number) {
    makeObservable(this);
    this.lessonId = lessonId;
    this.save = null;
  }

  @action
  complete() {
    if (this.save?.isPending === true)
      return;
    this.save = contentLoaders.x5lesson.delete(this.lessonId);
  }
}
